import React, { 
    useState,
    useEffect
} from 'react';
import ArrowIcon from '../svg/arrow';

const Carousel = ({
  children,
  stacked = false,
  buttonText = null,
  carouselIndex = 0,
  setCarouselIndex = null
}) => {
  const total = React.Children.count(children);

  const goToPrevSlide = () => {
    setCarouselIndex((prevIndex) => (prevIndex === 0 ? total - 1 : prevIndex - 1));
  };

  const goToNextSlide = () => {
    setCarouselIndex((prevIndex) => (prevIndex === total - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (!children || !carouselIndex) return;

    if (carouselIndex > (children.length - 1)) {
        setCarouselIndex(children.length - 1);
    }
    
  }, [carouselIndex])

  return (
    <div className={`carousel ${stacked ? 'carousel--stacked' : 'carousel--slider'}`}>
        <div
            className={`carousel__track ${stacked ? 'carousel__track--stacked' : ''}`}
            style={!stacked ? { transform: `translateX(-${carouselIndex * 100}%)` } : { paddingBottom: `${total * 5}px` }}
        >
            {React.Children.map(children, (child, index) => {
            const isActive = index === carouselIndex;
            const offset = index < carouselIndex ? index : total - index;

            return (
                <div key={child.key || index}
                    className={`carousel__slide ${stacked ? 'carousel__slide--stacked' : ''} ${
                        isActive ? 'carousel__slide--active' : ''
                    }`}
                    style={
                        stacked
                        ? isActive
                            ? { transform: 'translate(0, 0)', zIndex: 1, opacity: 1 }
                            : {
                                transform: `translate(${offset * 5}px, ${offset * 5}px)`,
                                zIndex: 0,
                                opacity: 0.5,
                            }
                        : {}
                    }
                    aria-hidden={!isActive}
                    tabIndex="0"
                    onFocus={() => setCarouselIndex(index)}
                    onClick={() => {if(!isActive) setCarouselIndex(index)}}>
                {child}
                </div>
            );
            })}
        </div>

        {!stacked ?
            buttonText ?
                <div className='carousel__controls'> 
                    <button type="button"
                            className='carousel__controls--prev__text'
                            onClick={goToPrevSlide}
                            disabled={carouselIndex == 0}>
                        <ArrowIcon />
                        <span>{buttonText.prev}</span>
                    </button>
                    <button type="button"
                            className='carousel__controls--next__text'
                            onClick={goToNextSlide}
                            disabled={carouselIndex == total - 1}>
                        <span>{buttonText.next}</span>
                        <ArrowIcon />
                    </button>
                </div>
            :
                <div className='carousel__controls'> 
                    <button type="button" 
                            className='carousel__controls--prev'
                            onClick={goToPrevSlide}
                            disabled={carouselIndex == 0}>
                        <span class="sr-text">Previous</span>
                        <ArrowIcon />
                    </button>
                    <button type="button"
                            className='carousel__controls--next'
                            onClick={goToNextSlide}
                            disabled={carouselIndex == total - 1}>
                        <span class="sr-text">Next</span>
                        <ArrowIcon />
                    </button>
                </div>
            : null
        }
    </div>
  );
};

export default Carousel;
